import { Grid, TableCell, TableRow } from "@mui/material";
import { cellWidePaddingStyle, orderSummaryTableStyle } from "./OrderSummaryTableStyles";
import React from "react";
import { grey } from "@mui/material/colors";
import { getDisplaySize } from "../../../../../utils/Items";
import { SummaryTotalTable } from "./SummaryTotalTable";
import { SummaryDetailRow } from "./SummaryDetailRow";

const SummaryTotalCellContent = ({ SummaryTables }) => (
  <Grid container
    minHeight="100%"
    sx={{
      "& > :not(:last-child)" : { 
        borderRight: `1px ${grey[200]} solid`
      }
    }}
    spacing={1}
  >
    {
      SummaryTables.map((table) => (
        <Grid item xs minWidth={"100px"}>
          {table}
        </Grid>
      ))
    }    
  </Grid>
);

const SummaryDetailCellContent = ({ details }) => (
  <>
   {details?.map((detail) => <SummaryDetailRow detail={detail} />)}
  </>
);

const OrderSummaryTableRow = ({order}) => {

  const priceTableColumnSx = {
    fontSize: 18,
  };

  const {product, totals, details} = order;

  const SummaryTotalTables = groupingByTotalType(totals).map((totals) => SummaryTotalTable(totals));

  return (    
    <TableRow>
      <TableCell
        component="th"
        scope="row"
        sx={{
          ...priceTableColumnSx,
          fontWeight: "bold",
          fontSize: 20,
          ...orderSummaryTableStyle.productName,
        }}
      >
        {product.productName}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, ...orderSummaryTableStyle.originName }}
      >
        {product.originName}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, ...orderSummaryTableStyle.size, borderRight: `1px ${grey[200]} solid` }}
      >
        {
          getDisplaySize(
            product.rankName, 
            product.productClassName,
            product.weight,
            product.weightUnitName,
            product.packingName,
            null
          )
        }
      </TableCell>
      <TableCell
        sx={{...priceTableColumnSx, ...orderSummaryTableStyle.details}}
      >
        {
          details
            ? <SummaryDetailCellContent details={details} />
            : null
        }
      </TableCell>

      <TableCell
        sx={{
          ...priceTableColumnSx, ...orderSummaryTableStyle.total,
          py: 3,
          minHeight: 28,
          verticalAlign: "top",
          borderRight: `1px ${grey[200]} solid`
        }}
      >
        {
          totals
            ? 
                <SummaryTotalCellContent
                  SummaryTables={SummaryTotalTables}
                />
              
            : null
        }
      </TableCell>
    </TableRow>
  )
}

export default OrderSummaryTableRow;


const groupingByTotalType = (totals) => {
  const totalTypeNos = [1, 2, 3];

  return totalTypeNos.map((typeNo) => 
    totals.filter((total) => total.summaryTotalTypeNo == typeNo)
  )

}

